import React, { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { IPodiumSettings, ISpeaker } from "../../app/models/podium";
import PodiumLogoutButton from "./PodiumLogoutButton";
import PodiumQRButton from "./PodiumQRButton";
import PodiumSpeakerIconComponent from "./PodiumSpeakerIconComponent";
import PodiumSpeakerPinForm from "./PodiumSpeakerPinForm";
import PodiumStandbyButton from "./PodiumStandbyButton";

interface IParams {
  speakers: ISpeaker[];
  settings: IPodiumSettings;
  preview : boolean;
}

const PodiumSpeakersContainer: React.FC<IParams> = ({ speakers, settings, preview }) => {
  const speakersContainer = useRef<HTMLDivElement>(null);
  const [requireSpeakerPin, setrequireSpeakerPin] = useState<ISpeaker | null>(
    null
  );
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);
  const [showSpeakers, setShowSpeakers] = useState(false);
  const cellWidth = width / settings.numberColumns;
  const cellHeight =
    height / Math.ceil(speakers.length / settings.numberColumns);
  const speakerSize = Math.min(cellWidth, cellHeight);
  const history = useHistory();

  const handleResize = () => {
    setShowSpeakers(false);
    if (speakersContainer.current) {
      setWidth(speakersContainer.current.getBoundingClientRect().width);
      setHeight(speakersContainer.current.getBoundingClientRect().height);
      setShowSpeakers(true);
    }
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  
    const redirectToSpeakerPage = (speakerId: number) => {
      if(preview===false){
      history.push(`podium/${speakerId}`);
      }
    };

    const onSpeakerClick = (speaker: ISpeaker) => {
      if(preview===false){
      if (speaker.requiresPin) {
        setrequireSpeakerPin(speaker);
      } else redirectToSpeakerPage(speaker.id);
      }
    };
 
  return (
    <>
      <div className={"h-100 w-100 " + settings.alignment} ref={speakersContainer}>
        {requireSpeakerPin ? (
          <PodiumSpeakerPinForm
            speaker={requireSpeakerPin}
            onPinOK={() => redirectToSpeakerPage(requireSpeakerPin.id)}
            onCancelClick={() => setrequireSpeakerPin(null)}
          />
        ) : (
          <>
            <PodiumStandbyButton className="podium-top-left-btn" />
            <PodiumLogoutButton isPreview={preview} className="podium-top-right-btn" />
            <PodiumQRButton className="podium-bottom-left-btn" />
            {showSpeakers && speakers.map((s) => (
              <div
                key={s.id}
                className="podium-speaker-cell"
                style={{
                  width: cellWidth,
                  height: cellHeight,
                }}
              >
                <PodiumSpeakerIconComponent
                  speaker={s}
                  showTag={settings.showTag}
                  tagColor={settings.tagColor}
                  tagFont={settings.iconFont}
                  tagFontSize={settings.iconFontSize}
                  tagFontColor={settings.iconFontColor}
                  divSize={speakerSize}
                  onSpeakerClick={() => onSpeakerClick(s)}
                />
              </div>
            ))}
          </>
        )}
      </div>
    </>
  );
};

export default PodiumSpeakersContainer;
